import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function ErtigaOnRentInMumbai() {



    const cardData = {





keyword: "Ertiga On Rent in Mumbai",

headingDescription: "Shreesha Tours & Travels offers affordable and comfortable Ertiga on Rent in Mumbai for airport transfers, outstation travel, corporate transportation, family vacations, business trips, sightseeing tours, pilgrimage journeys, destination weddings, and long-distance travel across India. The Maruti Suzuki Ertiga is one of the most preferred MPVs for its spacious cabin, comfortable seating, fuel efficiency, and generous luggage space, making it an excellent choice for families, small groups, and corporate travelers. Our chauffeur-driven Ertiga rental service includes experienced drivers, well-maintained vehicles, doorstep pickup, transparent pricing, flexible booking options, and 24/7 customer support. Whether you need an Ertiga for a one-way trip, round-trip journey, airport pickup, weekend getaway, or customized outstation tour, Shreesha Tours & Travels ensures a safe, reliable, and hassle-free travel experience. Our Ertiga rental service from Mumbai is ideal for travelers looking for an economical yet spacious vehicle with premium comfort for both short and long-distance journeys.",

topPlaces: [
  {
    title: "Mumbai to Pune",
    description: "Pune is one of the most popular destinations for Ertiga rentals from Mumbai. Families, corporate professionals, and students frequently book Ertiga cabs for comfortable travel to Hinjawadi, Baner, Kharadi, Magarpatta, Wakad, and Pimpri-Chinchwad."
  },
  {
    title: "Mumbai to Lonavala",
    description: "Lonavala is a scenic hill station famous for Tiger Point, Bhushi Dam, Rajmachi Fort, waterfalls, and lush green valleys. Ertiga rentals are an ideal choice for weekend getaways and family road trips."
  },
  {
    title: "Mumbai to Mahabaleshwar",
    description: "Mahabaleshwar is known for Venna Lake, Arthur's Seat, Mapro Garden, strawberry farms, and beautiful viewpoints. Ertiga offers a comfortable and spacious travel experience for families and groups."
  },
  {
    title: "Mumbai to Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations, attracting devotees throughout the year. Ertiga rentals provide convenient and comfortable transportation for religious tours with family members."
  },
  {
    title: "Mumbai to Nashik",
    description: "Nashik is renowned for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, and industrial areas. Ertiga rentals are popular for pilgrimage tours, business visits, and leisure travel."
  },
  {
    title: "Mumbai to Goa",
    description: "Goa is India's favorite beach destination with beautiful beaches, luxury resorts, churches, forts, nightlife, and water sports. Ertiga is a preferred vehicle for comfortable long-distance vacations."
  },
  {
    title: "Mumbai to Alibaug",
    description: "Alibaug is a beautiful coastal getaway famous for beaches, sea forts, luxury resorts, and peaceful surroundings. Families frequently choose Ertiga rentals for short weekend holidays."
  },
  {
    title: "Mumbai to Surat",
    description: "Surat is a major commercial city known for its textile and diamond industries. Business travelers often book Ertiga rentals for convenient intercity corporate travel."
  },
  {
    title: "Mumbai to Ahmedabad",
    description: "Ahmedabad is Gujarat's commercial and cultural capital with business hubs, industries, shopping destinations, and heritage attractions. Ertiga rentals offer comfortable transportation for both business and leisure travelers."
  },
  {
    title: "Mumbai to Indore",
    description: "Indore is the commercial capital of Madhya Pradesh, known for Rajwada Palace, Sarafa Night Market, Khajrana Ganesh Temple, and nearby Ujjain. Ertiga rentals are an excellent option for long-distance family and business travel."
  }
],



"services": [
  {
    "name": "Ertiga On Rent in Mumbai",
    "description": "Book Ertiga On Rent in Mumbai for comfortable chauffeur-driven travel with spacious 6 to 7 seater AC vehicles, professional drivers, and affordable rental packages. Ideal for airport transfers, family vacations, corporate travel, sightseeing, weddings, weekend trips, business meetings, and outstation journeys with safe, reliable, and well-maintained vehicles available 24x7."
  },
  {
    "name": "Maruti Ertiga Rental Mumbai",
    "description": "Choose Maruti Ertiga Rental Mumbai for smooth and comfortable travel with clean AC vehicles, experienced chauffeurs, and flexible rental options. Our Ertiga rentals are perfect for family outings, airport transfers, corporate travel, holiday tours, pilgrimage trips, hotel transfers, and long-distance outstation journeys."
  },
  {
    "name": "Ertiga Cab Service Mumbai",
    "description": "Hire Ertiga Cab Service Mumbai for reliable transportation with spacious seating, professional drivers, and affordable fares. Travel comfortably for local city rides, airport pickup and drop, family functions, business meetings, sightseeing tours, and outstation travel with convenient online booking."
  },
  {
    "name": "Ertiga Car Rental Mumbai",
    "description": "Reserve Ertiga Car Rental Mumbai for safe and hassle-free travel with chauffeur-driven vehicles offering comfortable seating and generous luggage space. Perfect for family travel, corporate events, weddings, local sightseeing, airport transfers, and interstate road trips."
  },
  {
    "name": "Ertiga Hire Mumbai",
    "description": "Book Ertiga Hire Mumbai for premium chauffeur-driven transportation with experienced drivers and well-maintained AC vehicles. Enjoy comfortable travel for personal trips, business visits, family vacations, airport transfers, religious tours, and weekend getaways."
  },
  {
    "name": "Ertiga Taxi Mumbai",
    "description": "Choose Ertiga Taxi Mumbai for affordable and dependable transportation with professional chauffeurs and spacious vehicles. Suitable for local travel, airport transfers, office commutes, family functions, corporate travel, and long-distance outstation journeys."
  },
  {
    "name": "Ertiga with Driver Mumbai",
    "description": "Hire Ertiga with Driver Mumbai for stress-free travel with courteous chauffeurs, clean vehicles, and flexible travel schedules. Ideal for business executives, family holidays, airport transfers, wedding transportation, sightseeing tours, and comfortable road trips."
  },
  {
    "name": "Ertiga Outstation Cab Mumbai",
    "description": "Book Ertiga Outstation Cab Mumbai for one way and round trip travel across Maharashtra, Goa, Gujarat, Karnataka, and other destinations. Enjoy spacious seating, comfortable interiors, experienced drivers, transparent pricing, and reliable service for family vacations, corporate tours, and pilgrimage travel."
  },
  {
    "name": "Ertiga Airport Taxi Mumbai",
    "description": "Reserve Ertiga Airport Taxi Mumbai for timely airport pickup and drop services with flight tracking, luggage assistance, and professional chauffeurs. Travel comfortably to and from Mumbai Airport with spacious vehicles designed for families, business travelers, and group transfers."
  },
  {
    "name": "Ertiga Corporate Cab Mumbai",
    "description": "Choose Ertiga Corporate Cab Mumbai for executive transportation, employee travel, airport transfers, client meetings, conferences, and office travel. Our chauffeur-driven Ertiga cabs provide punctual, professional, and comfortable corporate transportation solutions."
  },
  {
    "name": "Ertiga Family Trip Cab Mumbai",
    "description": "Book Ertiga Family Trip Cab Mumbai for safe and enjoyable family journeys with spacious seating, large luggage capacity, and experienced chauffeurs. Perfect for vacations, sightseeing tours, weddings, religious trips, weekend holidays, and outstation travel."
  },
  {
    "name": "Mumbai Ertiga Cab Booking",
    "description": "Complete Mumbai Ertiga Cab Booking online with instant confirmation, affordable pricing, and multiple travel options. Reserve spacious chauffeur-driven Ertiga cabs for airport transfers, local rides, business meetings, family functions, and long-distance travel."
  },
  {
    "name": "Ertiga One Way Cab Mumbai",
    "description": "Book Ertiga One Way Cab Mumbai for economical single-trip travel without return fare charges. Enjoy fixed pricing, comfortable AC vehicles, professional chauffeurs, and convenient pickup services for airport transfers, business travel, and intercity transportation."
  },
  {
    "name": "Ertiga Round Trip Taxi Mumbai",
    "description": "Reserve Ertiga Round Trip Taxi Mumbai for flexible return journeys with affordable travel packages and experienced drivers. Ideal for sightseeing, family holidays, pilgrimage tours, corporate travel, weddings, and weekend getaways with complete travel convenience."
  },
  {
    "name": "Affordable Ertiga Rental Mumbai",
    "description": "Choose Affordable Ertiga Rental Mumbai for budget-friendly chauffeur-driven transportation without compromising comfort or safety. Enjoy spacious vehicles, transparent pricing, experienced drivers, and reliable travel solutions for airport transfers, family travel, business trips, and outstation journeys."
  },
  {
    "name": "Best Ertiga Car Rental Mumbai",
    "description": "Book the Best Ertiga Car Rental Mumbai for premium travel with clean AC vehicles, courteous chauffeurs, competitive pricing, and dependable customer support. Whether you require transportation for airport transfers, family vacations, corporate travel, weddings, sightseeing tours, or long-distance outstation journeys, our Ertiga rental service delivers a safe, comfortable, and memorable travel experience."
  }
],
"tableData": [
  ["Ertiga On Rent in Mumbai", "Maruti Ertiga Rental Mumbai"],
  ["Ertiga Cab Service Mumbai", "Ertiga Car Rental Mumbai"],
  ["Ertiga Hire Mumbai", "Ertiga Taxi Mumbai"],
  ["Ertiga with Driver Mumbai", "Ertiga Outstation Cab Mumbai"],
  ["Ertiga Airport Taxi Mumbai", "Ertiga Corporate Cab Mumbai"],
  ["Ertiga Family Trip Cab Mumbai", "Mumbai Ertiga Cab Booking"],
  ["Ertiga One Way Cab Mumbai", "Ertiga Round Trip Taxi Mumbai"],
  ["Affordable Ertiga Rental Mumbai", "Best Ertiga Car Rental Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Ertiga on Rent in Mumbai",
    WhyChoosedescription: "Shreesha Travels offers well-maintained Maruti Ertiga rental services in Mumbai for airport transfers, family outings, corporate travel, sightseeing tours, weekend getaways, and outstation trips. Enjoy spacious seating and a smooth ride with our chauffeur-driven Ertiga cabs."
  },
  {
    WhyChooseheading: "A Smart Choice for Family & Group Travel",
    WhyChoosedescription: "The Ertiga is designed to accommodate families and small groups comfortably, providing generous legroom, luggage space, and excellent ride quality for both city and highway travel."
  },
  {
    WhyChooseheading: "Suitable for Local & Long-Distance Journeys",
    WhyChoosedescription: "Book an Ertiga for travel within Mumbai or plan trips to Pune, Lonavala, Shirdi, Nashik, Mahabaleshwar, Goa, Surat, Ahmedabad, Kolhapur, and many more destinations with complete travel flexibility."
  },
  {
    WhyChooseheading: "Perfect Vehicle for Business & Personal Travel",
    WhyChoosedescription: "Whether it's an office meeting, airport transfer, hotel pickup, family celebration, pilgrimage, or holiday vacation, the Ertiga delivers comfort and convenience for every occasion."
  },
  {
    WhyChooseheading: "Flexible Rental Plans to Match Every Itinerary",
    WhyChoosedescription: "Select from one-way transfers, round-trip bookings, hourly rentals, full-day packages, multi-day tours, or customized travel plans according to your schedule."
  },
  {
    WhyChooseheading: "Professional Chauffeurs with Route Expertise",
    WhyChoosedescription: "Our experienced drivers ensure timely pickups, courteous service, safe driving practices, and efficient route planning to make every journey enjoyable."
  },
  {
    WhyChooseheading: "Clean, Air-Conditioned & Regularly Serviced Ertiga",
    WhyChoosedescription: "Every Ertiga is thoroughly cleaned, inspected, and serviced before every trip to provide passengers with a comfortable, reliable, and safe travel experience."
  },
  {
    WhyChooseheading: "Book Your Ertiga with Shreesha Travels",
    WhyChoosedescription: "Benefit from transparent pricing, prompt customer assistance, and dependable chauffeur-driven transportation whenever you need an Ertiga on rent in Mumbai."
  }
]

};

const faqData = [
  {
    question: "Why should I choose an Ertiga on rent in Mumbai?",
    answer: "The Maruti Ertiga offers comfortable seating, good luggage space, excellent fuel efficiency, and is an ideal choice for families, business travellers, and small groups."
  },
  {
    question: "How many passengers can travel in an Ertiga?",
    answer: "The Ertiga comfortably accommodates up to 6–7 passengers, depending on luggage requirements and seating configuration."
  },
  {
    question: "Is the Ertiga available for airport transfers?",
    answer: "Yes, chauffeur-driven Ertiga rentals are available for Mumbai Airport pickups and drop-offs at both domestic and international terminals."
  },
  {
    question: "Can I hire an Ertiga for outstation travel?",
    answer: "Yes, Ertiga rentals are available for one-way trips, round trips, weekend holidays, business tours, and long-distance journeys."
  },
  {
    question: "Do you provide Ertiga rentals for corporate travel?",
    answer: "Yes, the Ertiga is frequently booked for executive travel, office meetings, conferences, employee transportation, and client visits."
  },
  {
    question: "Can I reserve an Ertiga for weddings and family events?",
    answer: "Yes, the Ertiga is suitable for wedding transportation, family functions, airport guest pickups, and special occasions."
  },
  {
    question: "Are multi-day Ertiga rental packages available?",
    answer: "Yes, we offer customized multi-day rental packages for vacations, pilgrimages, road trips, and business travel."
  },
  {
    question: "How is the Ertiga rental fare calculated?",
    answer: "Rental charges depend on the travel distance, trip duration, destination, selected package, and any additional travel requirements."
  },
  {
    question: "Can I book an Ertiga in advance?",
    answer: "Yes, advance reservations are recommended to ensure vehicle availability, especially during weekends and festive seasons."
  },
  {
    question: "How can I book an Ertiga on Rent in Mumbai with Shreesha Travels?",
    answer: "Simply share your pickup location, destination, travel dates, passenger count, and preferred itinerary to receive a personalized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Chirag Mehta",
    feedback: "The Ertiga provided the perfect balance of comfort and space for our journey. The ride remained smooth throughout, and the chauffeur's professionalism added to an excellent travel experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Poonam Agarwal",
    feedback: "Everything from the reservation process to the final drop-off was managed efficiently. The spacious cabin, comfortable seating, and punctual service made the trip pleasant from beginning to end.",
    rating: 5
  }
];












    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga On Rent in Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/ertiga-on-rent-in-mumbai.webp",
  "description":
    "Book Ertiga On Rent in Mumbai with Shreesha Tours & Travels for comfortable, spacious, and affordable chauffeur-driven car rental services. We provide Maruti Ertiga cabs available 24x7 for airport transfers, family trips, corporate travel, group journeys, sightseeing tours, weddings, and outstation travel with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/ertiga-on-rent-in-mumbai"
  }
};








    return (
        <div>

<Helmet>
  <title>Ertiga On Rent in Mumbai | 7 Seater Cab Rental | +91 8355835813</title>

  <meta
    name="description"
    content="Book Ertiga On Rent in Mumbai with Shreesha Travels for reliable 7 seater cab rental services. Hire Maruti Ertiga with driver for airport transfers, corporate travel, family trips, sightseeing, and outstation journeys with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Ertiga On Rent in Mumbai, Maruti Ertiga Rental Mumbai, Ertiga Cab Service Mumbai, Ertiga Car Rental Mumbai, Ertiga Hire Mumbai, Ertiga Taxi Mumbai, Ertiga with Driver Mumbai, Ertiga Outstation Cab Mumbai, Ertiga Airport Taxi Mumbai, Ertiga Corporate Cab Mumbai, Ertiga One Way Cab Mumbai, Ertiga Round Trip Taxi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/50.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default ErtigaOnRentInMumbai;